/**
 * @fileoverview Exemption from FATCA reporting code options for W9 tax form
 * @description Provides a frozen array of exemption from FATCA reporting code options (A-M) for use in W9 tax form dropdown selections.
 * Each option contains a label and value pair representing the IRS exemption from FATCA reporting codes.
 */

/**
 * Frozen array of exemption from FATCA reporting code options for W9 tax form
 * @constant {Array<{label: string, value: string}>} ExemptionFromFatcaReportingCodeOptions
 * @description Contains exemption from FATCA reporting codes A-M as defined by IRS Form W-9.
 * These codes indicate various types of exemptions from Foreign Account Tax Compliance Act (FATCA) reporting.
 */
export const ExemptionFromFatcaReportingCodeOptions = Object.freeze([
    { label: "A", value: "A" },
    { label: "B", value: "B" },
    { label: "C", value: "C" },
    { label: "D", value: "D" },
    { label: "E", value: "E" },
    { label: "F", value: "F" },
    { label: "G", value: "G" },
    { label: "H", value: "H" },
    { label: "I", value: "I" },
    { label: "J", value: "J" },
    { label: "K", value: "K" },
    { label: "L", value: "L" },
    { label: "M", value: "M" }
]);